import { ProtocolHistoryModalComponent } from './protocol-history-modal/protocol-history-modal.component';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ProtocolModel } from '../models/protocol.model';
import { map, Observable } from 'rxjs';


@Component({
  selector: 'app-protocol-history',
  templateUrl: './protocol-history.component.html',
  styleUrls: ['./protocol-history.component.scss']
})
export class ProtocolHistoryComponent implements OnInit {
  @Input() history$!: Observable<ProtocolModel | null>;
  displayedColumns: string[] = ['investigator', 'created', 'createdBy', 'actions'];
  sortedHistory$!: Observable<ProtocolModel | null>;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.sortedHistory$ = this.history$.pipe(
      map(history => history ? ({
        ...history,
        protocolHistories: [...(history.protocolHistories ?? [])].sort((a, b) => {
          // Try protocolHistoryId first
          const aId = a.protocolHistoryId ?? a.id ?? 0;
          const bId = b.protocolHistoryId ?? b.id ?? 0;

          if (aId !== bId) {
            return bId - aId; // DESC by ID
          }

          // Fallback to created date DESC
          const aCreated = a.created ? new Date(a.created).getTime() : 0;
          const bCreated = b.created ? new Date(b.created).getTime() : 0;
          return bCreated - aCreated;
        })
      }) : null)
    );
  }

  view(model: ProtocolModel): void {
    this.dialog.open(ProtocolHistoryModalComponent, { data: model });
  }

}
